import { object, mixed, number } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

const DAYS_IN_YEAR = 365
const HOURS_IN_YEAR = 8765
const MINS_IN_YEAR = 525900

export const getValidationSchema = () => object({
  minBookingTime: mixed()
    .when('minBookingTimeType', {
      is: (type) => type === 'mins',
      then: number()
        .typeError(I18n.t('errors.messages.not_a_number'))
        .min(0, I18n.t('errors.messages.greater_than', { count: 0 }))
        .max(MINS_IN_YEAR, I18n.t('errors.messages.less_than', { count: MINS_IN_YEAR }))
    })
    .when('minBookingTimeType', {
      is: (type) => type === 'hours',
      then: number()
        .typeError(I18n.t('errors.messages.not_a_number'))
        .min(0, I18n.t('errors.messages.greater_than', { count: 0 }))
        .max(HOURS_IN_YEAR, I18n.t('errors.messages.less_than', { count: HOURS_IN_YEAR }))
    })
    .when('minBookingTimeType', {
      is: (type) => type === 'days',
      then: number()
        .typeError(I18n.t('errors.messages.not_a_number'))
        .min(0, I18n.t('errors.messages.greater_than', { count: 0 }))
        .max(DAYS_IN_YEAR, I18n.t('errors.messages.less_than', { count: DAYS_IN_YEAR }))
    }),
})
